"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _storePoint = require("@/api/storePoint");
var _distribution = require("@/api/distribution");
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _systemConfig = require("@/api/systemConfig");
var _index = _interopRequireDefault(require("../../../../appSetting/wxAccount/wxTemplate/index"));
var _validate = require("@/utils/validate");
var _amap = require("@/utils/amap");
var _UserSearchInput = _interopRequireDefault(require("@/components/base/UserSearchInput.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'index',
  components: {
    Templates: _index.default,
    UserSearchInput: _UserSearchInput.default
  },
  // props: {
  //   children: 'child',
  //   label: 'name',
  //   value: 'name'
  // },
  data: function data() {
    var _this2 = this;
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };
    var validateUpload = function validateUpload(rule, value, callback) {
      if (!_this2.ruleForm.image) {
        callback(new Error('请上传提货点logo'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogFormVisible: false,
      addresData: [],
      // 添加团长弹窗
      promoterDialog: false,
      promoterList: [],
      // 团长表格数据
      promoterLoading: false,
      promoterTotal: 0,
      promoterRadio: null,
      // 当前选中行 uid
      promoterSelected: null,
      // 当前选中团长
      amap: null,
      amapMarker: null,
      promoterFrom: {
        page: 1,
        limit: 10,
        searchType: 'all',
        content: ''
      },
      ruleForm: {
        name: '',
        introduction: '',
        phone: '',
        address: '',
        detailedAddress: '',
        dayTime: '',
        image: '',
        latitude: '',
        longitude: '',
        promoterId: null,
        promoterName: ''
      },
      id: 0,
      dayTime: ['', ''],
      rules: {
        name: [{
          required: true,
          message: '请输入提货点名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请选择提货点地址',
          trigger: 'change'
        }],
        dayTime: [{
          required: true,
          type: 'array',
          message: '请选择提货点营业时间',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        promoterId: [{
          required: true,
          message: '请选择所属团长',
          trigger: 'change'
        }],
        detailedAddress: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          validator: validateUpload,
          trigger: 'change'
        }],
        latitude: [{
          required: true,
          message: '请选择经纬度',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.ruleForm.image = '';
    var cityList = JSON.parse(sessionStorage.getItem('cityList'));
    this.addresData = cityList;
    this.getCityList();
  },
  watch: {
    // 弹窗打开后再初始化地图（容器 v-if 渲染完成），关闭时销毁
    dialogFormVisible: function dialogFormVisible(val) {
      var _this3 = this;
      if (val) {
        this.$nextTick(function () {
          return _this3.initMap();
        });
      } else {
        this.destroyMap();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyMap();
  },
  methods: {
    //详情
    getInfo: function getInfo(id) {
      var _this4 = this;
      var that = this;
      that.id = id;
      this.loading = true;
      (0, _storePoint.storeInfoApi)({
        id: id
      }).then(function (res) {
        that.ruleForm = res;
        that.ruleForm.address = res.address.split(',');
        that.normalizeStoreLocation(res);
        that.dayTime = res.dayTime.split(',');
        // 所属团长回显：ruleForm 已含 promoterId/promoterName，表单项直接展示
        _this4.loading = false;
        // 详情返回后重新初始化地图，定位到已保存的经纬度
        _this4.$nextTick(function () {
          return _this4.initMap();
        });
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.ruleForm.image = '';
      this.resetForm('ruleForm');
      this.id = 0;
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 提交
    submitForm: (0, _validate.Debounce)(function (name) {
      var _this5 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _storePoint.storeSaveApi)(_this5.ruleForm).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _this5.$message.success('提交成功');
                  _this5.dialogFormVisible = false;
                  _this5.$parent.tableList();
                  _this5.$parent.storeGetCount();
                  _this5.clearFrom();
                  _this5.resetForm(name);
                  _this5.id = 0;
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          })));
        } else {
          return false;
        }
      });
    }),
    //编辑
    editForm: (0, _validate.Debounce)(function (name) {
      var _this6 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this6.handleChange(_this6.ruleForm.address);
          (0, _storePoint.storeUpdateApi)(_this6.ruleForm, _this6.id).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _this6.$message.success('编辑成功');
                  _this6.dialogFormVisible = false;
                  _this6.$parent.tableList();
                  _this6.clearFrom();
                  _this6.resetForm(name);
                  _this6.id = 0;
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          })));
        } else {
          return false;
        }
      });
    }),
    //数据归为初始状态
    clearFrom: function clearFrom() {
      this.ruleForm.introduction = '';
      this.ruleForm.promoterId = null;
      this.ruleForm.promoterName = '';
      this.dayTime = ['', ''];
    },
    // 打开「添加团长」弹窗
    openPromoterDialog: function openPromoterDialog() {
      this.promoterFrom.page = 1;
      this.promoterFrom.searchType = 'all';
      this.promoterFrom.content = '';
      // 回显当前已选
      this.promoterRadio = this.ruleForm.promoterId || null;
      this.promoterSelected = this.ruleForm.promoterId ? {
        uid: this.ruleForm.promoterId,
        nickname: this.ruleForm.promoterName
      } : null;
      this.promoterDialog = true;
      this.getPromoterList();
    },
    // 团长列表
    getPromoterList: function getPromoterList() {
      var _this7 = this;
      this.promoterLoading = true;
      (0, _distribution.promoterListApi)(_objectSpread({}, this.promoterFrom)).then(function (res) {
        _this7.promoterList = res.list || [];
        _this7.promoterTotal = res.total || 0;
        _this7.promoterLoading = false;
      }).catch(function () {
        _this7.promoterLoading = false;
      });
    },
    promoterSearch: function promoterSearch() {
      this.promoterFrom.page = 1;
      this.getPromoterList();
    },
    resetPromoterSearch: function resetPromoterSearch() {
      this.promoterFrom.searchType = 'all';
      this.promoterFrom.content = '';
      this.promoterFrom.page = 1;
      this.getPromoterList();
    },
    // 选中某行团长
    selectPromoterRow: function selectPromoterRow(row) {
      this.promoterRadio = row.uid;
      this.promoterSelected = row;
    },
    // 确定选择团长
    confirmPromoter: function confirmPromoter() {
      if (!this.promoterSelected) return this.$message.warning('请选择团长');
      this.ruleForm.promoterId = this.promoterSelected.uid;
      this.ruleForm.promoterName = this.promoterSelected.nickname;
      if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('promoterId');
      this.promoterDialog = false;
    },
    promoterPageChange: function promoterPageChange(page) {
      this.promoterFrom.page = page;
      this.getPromoterList();
    },
    promoterSizeChange: function promoterSizeChange(val) {
      this.promoterFrom.limit = val;
      this.getPromoterList();
    },
    //确认省市区
    handleChange: function handleChange(e) {
      var province = e[0];
      var city = e[1];
      var area = e[2];
      if (e.length === 2) {
        this.ruleForm.address = province + ',' + city;
      } else if (e.length === 3) {
        this.ruleForm.address = province + ',' + city + ',' + area;
      }
    },
    //营业时间
    onchangeTime: function onchangeTime(e) {
      this.ruleForm.dayTime = e ? e.join(',') : '';
    },
    //上传图片
    modalPicTap: function modalPicTap(tit) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.ruleForm.image = img[0].sattDir;
      }, tit, 'system');
    },
    // 初始化内嵌高德地图
    initMap: function initMap() {
      var _this8 = this;
      (0, _amap.loadAMap)().then(function () {
        if (!document.getElementById('addPointAmapContainer')) return;
        if (_this8.amap) _this8.destroyMap();
        var loc = _this8.parseLngLat();
        var center = loc || [108.940175, 34.341568];
        _this8.amap = new AMap.Map('addPointAmapContainer', {
          zoom: 15,
          center: center
        });
        _this8.amap.on('click', _this8.onMapClick);
        if (loc) _this8.updateMarker(loc[0], loc[1]);
      }).catch(function () {
        _this8.$message.error('地图加载失败，请检查网络后重试');
      });
    },
    destroyMap: function destroyMap() {
      if (this.amap) {
        this.amap.destroy();
        this.amap = null;
        this.amapMarker = null;
      }
    },
    normalizeStoreLocation: function normalizeStoreLocation(data) {
      var lngLat = this.getLngLatFromStore(data);
      if (lngLat) {
        this.ruleForm.latitude = lngLat.join(',');
        this.ruleForm.longitude = String(lngLat[0]);
      }
    },
    getLngLatFromStore: function getLngLatFromStore(data) {
      var longitude = this.toValidLng(data.longitude);
      var latitude = this.toValidLat(String(data.latitude || '').split(',')[0]);
      if (longitude !== null && latitude !== null) return [longitude, latitude];
      return this.parseLocationString(data.latitude);
    },
    toValidLng: function toValidLng(value) {
      var num = Number(value);
      return Number.isFinite(num) && num >= -180 && num <= 180 ? num : null;
    },
    toValidLat: function toValidLat(value) {
      var num = Number(value);
      return Number.isFinite(num) && num >= -90 && num <= 90 ? num : null;
    },
    parseLocationString: function parseLocationString(value) {
      var parts = String(value || '').split(',').map(function (item) {
        return Number(item);
      });
      if (parts.length !== 2 || parts.some(function (item) {
        return !Number.isFinite(item);
      })) return null;
      if (this.toValidLng(parts[0]) !== null && this.toValidLat(parts[1]) !== null) return [parts[0], parts[1]];
      if (this.toValidLat(parts[0]) !== null && this.toValidLng(parts[1]) !== null) return [parts[1], parts[0]];
      return null;
    },
    // 解析当前表单经纬度（内部统一为 "经度,纬度"）
    parseLngLat: function parseLngLat() {
      return this.parseLocationString(this.ruleForm.latitude);
    },
    updateMarker: function updateMarker(lng, lat) {
      if (this.amapMarker) {
        this.amapMarker.setPosition([lng, lat]);
      } else {
        this.amapMarker = new AMap.Marker({
          position: [lng, lat],
          map: this.amap
        });
      }
      this.amap.setCenter([lng, lat]);
    },
    setRuleFormLocation: function setRuleFormLocation(lng, lat) {
      this.ruleForm.latitude = lng + ',' + lat;
      this.ruleForm.longitude = String(lng);
    },
    // 输入详细地址 → 地理编码定位
    searchLocation: function searchLocation() {
      var _this9 = this;
      var detailed = (this.ruleForm.detailedAddress || '').trim();
      if (!detailed) {
        this.$message.warning('请先输入详细地址');
        return;
      }
      if (!this.amap || !window.AMap || !window.AMap.Geocoder) {
        this.$message.warning('地图尚未加载完成，请稍后再试');
        return;
      }
      // 拼上省市区提高命中率
      var region = Array.isArray(this.ruleForm.address) ? this.ruleForm.address.join('') : String(this.ruleForm.address || '').replace(/,/g, '');
      var geocoder = new AMap.Geocoder({
        extensions: 'all'
      });
      geocoder.getLocation(region + detailed, function (status, result) {
        if (status === 'complete' && result.geocodes && result.geocodes.length) {
          var _result$geocodes$0$lo = result.geocodes[0].location,
            lng = _result$geocodes$0$lo.lng,
            lat = _result$geocodes$0$lo.lat;
          _this9.updateMarker(lng, lat);
          _this9.setRuleFormLocation(lng, lat);
          if (_this9.$refs.ruleForm) _this9.$refs.ruleForm.validateField('latitude');
          _this9.$message.success('定位成功');
        } else if (status === 'no_data') {
          _this9.$message.error('未找到该地址，请检查地址是否正确');
        } else {
          _this9.$message.error('地址搜索失败，请稍后重试');
        }
      });
    },
    // 点击地图 → 选点并逆地理编码回填详细地址
    onMapClick: function onMapClick(e) {
      var _this0 = this;
      var _e$lnglat = e.lnglat,
        lng = _e$lnglat.lng,
        lat = _e$lnglat.lat;
      this.updateMarker(lng, lat);
      this.setRuleFormLocation(lng, lat);
      if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('latitude');
      var geocoder = new AMap.Geocoder();
      geocoder.getAddress([lng, lat], function (status, result) {
        if (status === 'complete' && result.regeocode) {
          _this0.ruleForm.detailedAddress = result.regeocode.formattedAddress || _this0.ruleForm.detailedAddress;
          if (_this0.$refs.ruleForm) _this0.$refs.ruleForm.validateField('detailedAddress');
        }
      });
    },
    getCityList: function getCityList() {
      var _this1 = this;
      logistics.cityListTree().then(function (res) {
        sessionStorage.setItem('cityList', JSON.stringify(res));
        var cityList = JSON.parse(sessionStorage.getItem('cityList'));
        _this1.addresData = cityList;
      }).catch(function (res) {
        _this1.$message.error(res.message);
      });
    }
  }
};